module.exports = __webpack_public_path__ + "img/list04-sp.3d83d72b.png";